import { render, staticRenderFns } from "./\bchrelist.vue?vue&type=template&id=8553780e&"
import script from "./\bchrelist.vue?vue&type=script&lang=js&"
export * from "./\bchrelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports